import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { InlineNotice } from '@wit-support/ui';
import { EntityId } from '@wit-support/ui-domain';
import { Info } from 'lucide-react';
import { metaObjectKind, objectLabel } from '../naming.js';
/**
 * Одинаковые заметки по разным объектам (Meta делает одно и то же со всеми
 * группами) — одной строкой со списком объектов.
 */
function groupNotes(items) {
    const byText = new Map();
    for (const n of items) {
        const text = n.label !== '' ? n.label : n.path;
        const obj = {
            label: objectLabel(n.kind, n.localRef),
            kind: n.kind,
            metaId: n.metaId ?? null,
        };
        const g = byText.get(text) ?? { text, objects: [] };
        if (!g.objects.some((o) => o.label === obj.label && o.metaId === obj.metaId)) {
            g.objects.push(obj);
        }
        byText.set(text, g);
    }
    return [...byText.values()];
}
/**
 * «Заметки Meta» сверки (auto-ads `notes`, решение 160): факты, а не
 * расхождения — Meta так делает сама. Нейтральная плашка, не ошибка и не
 * предупреждение; на статус, гарантии и кнопки запуска не влияет. Нет
 * заметок — ничего.
 */
export function VerifyNotes({ items }) {
    if (items.length === 0)
        return null;
    const groups = groupNotes(items);
    return (_jsx(InlineNotice, { variant: "muted", bordered: true, icon: Info, as: "div", "data-testid": "verify-notes", children: _jsxs("div", { className: "flex min-w-0 flex-col gap-1", children: [_jsx("span", { className: "font-medium text-[var(--color-text-primary)]", children: "\u0417\u0430\u043C\u0435\u0442\u043A\u0438 Meta" }), _jsx("span", { children: "\u042D\u0442\u043E \u043D\u0435 \u043E\u0448\u0438\u0431\u043A\u0438: \u0442\u0430\u043A Meta \u0434\u0435\u043B\u0430\u0435\u0442 \u0441\u0430\u043C\u0430. \u0414\u0435\u043B\u0430\u0442\u044C \u043D\u0438\u0447\u0435\u0433\u043E \u043D\u0435 \u043D\u0443\u0436\u043D\u043E." }), _jsx("ul", { className: "flex flex-col gap-1", children: groups.map((g) => (_jsxs("li", { className: "flex flex-col [overflow-wrap:anywhere]", children: [_jsx("span", { className: "text-[var(--color-text-primary)]", children: g.text }), _jsx("span", { className: "flex flex-wrap items-center gap-x-1", children: g.objects.map((o, i) => (_jsxs("span", { className: "group/entity inline-flex items-center", children: [o.label, o.metaId != null ? (_jsx(EntityId, { id: o.metaId, kind: metaObjectKind(o.kind), className: "ml-1" })) : null, i < g.objects.length - 1 ? ',' : null] }, `${o.label}:${o.metaId ?? ''}`))) })] }, g.text))) })] }) }));
}
//# sourceMappingURL=verify-notes.js.map